import React from "react";
import Routes from "../Routes";
import { Link, useLocation } from "react-router-dom";
import { withUser } from "../Contexts/user";
import { IoIosLogOut } from "react-icons/io";
import { FiChevronLeft, FiChevronRight, FiMoon, FiSun, FiLock } from "react-icons/fi";
import { useSidebar } from "../Contexts/sidebar";

const Sidebar = ({ user }) => {
    const { isCollapsed, setIsCollapsed, isDarkMode, setIsDarkMode } =
        useSidebar();
  const location = useLocation();

  const isActiveRoute = (path) => {
    if (path === "/" && location.pathname === "/") return true;
    if (path !== "/" && location.pathname.startsWith(path)) return true;
    return false;
  };

    const capitalizeWords = str => {
        return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    };

  // Filter routes based on user type
    const visibleRoutes =
        user.auth.type === "manager"
            ? Routes.filter(
                  (route) =>
                      !route.hidden &&
                      (route.path === "/cases" ||
                          route.path === "/projects" ||
                          route.path === "/agency" ||
                          route.path === "/commissions")
              )
            : user.auth.type === "shareholder" ||
              user.auth.type === "agent" ||
              user.auth.type === "pd" ||
              user.auth.type === "sd"
            ? Routes.filter(
                  (route) =>
                      !route.hidden &&
                      (route.path === "/cases" ||
                       route.path === "/commissions")
              )
    : user.auth.type === "superadmin"
            ? Routes.filter((route) => !route.hidden && route.path !== "/change-password")
      : user.auth.type === "user"
            ? Routes.filter(
                  (route) =>
                      !route.hidden &&
                      (route.path === "/cases" ||
                          route.path === "/commissions" ||
                          route.path === "/new-case" ||
                          route.path === "/edit-case" ||
                          route.path === "/terms" ||
                          route.path === "/commissions")
              )
      : user.auth.type === "admin"
            ? Routes.filter(
                  (route) =>
                      !route.hidden &&
                      route.path !== "/new-case" &&
                      route.path !== "/projects" &&
                      route.path !== "/agency" &&
                      route.path !== "/users" &&
                      route.path !== "/terms" &&
                      route.path !== "/change-password"
              )
            : Routes.filter((route) => !route.hidden && !route.superadmin && route.path !== "/change-password");

  return (
        <div
            className={`${
                isDarkMode
                    ? "bg-gray-900 border-gray-700"
                    : "bg-white border-gray-200"
            } ${
                isCollapsed
                    ? "h-auto md:min-h-screen w-full md:w-16 border-b md:border-r md:border-b-0"
                    : "min-h-screen w-64 border-r"
            } flex-shrink-0 transition-all duration-300 flex flex-col`}
        >
      {/* Header Section */}
            <div
                className={`p-4 border-b ${
                    isDarkMode ? "border-gray-700" : "border-gray-200"
                }`}
            >
        <div className="flex items-center justify-between">
          {!isCollapsed && (
                        <img
                            src={isDarkMode ? "/logo-dark.png" : "/logo.png"}
                            alt="NFC Logo"
                            className="h-12"
                        />
                    )}
                    {isCollapsed && (
                        <img
                            src={isDarkMode ? "/logo-dark.png" : "/logo.png"}
                            alt="NFC Logo"
                            className="h-12 block md:hidden"
                        />
          )}
          <button 
                        className={`p-1 rounded-lg ${
                            isDarkMode
                                ? "hover:bg-gray-800 text-gray-400"
                                : "hover:bg-gray-100 text-gray-500"
                        }`}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
                        {isCollapsed ? (
                            <FiChevronRight size={20} />
                        ) : (
                            <FiChevronLeft size={20} />
                        )}
          </button>
        </div>
      </div>

      {/* User Profile Section */}
      {!isCollapsed && (
                <div
                    className={`p-4 border-b ${
                        isDarkMode ? "border-gray-700" : "border-gray-200"
                    }`}
                >
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-medium">
                                {user.auth.name?.charAt(0)?.toUpperCase() ||
                                    ""}
              </span>
            </div>
            <div>
                            <p
                                className={`text-sm font-medium ${
                                    isDarkMode
                                        ? "text-gray-100"
                                        : "text-gray-900"
                                }`}
                            >
                                {user.auth.name && capitalizeWords(user.auth.name)}
                            </p>
              <p className="text-xs text-orange-400 font-medium">
                {user.auth.type === "agent"
                  ? "Property Agent"
                  : user.auth.type === "user"
                  ? "NFC Agent"
                  : user.auth.type === "pd"
                  ? "Project Director"
                  : user.auth.type === "sd"
                  ? "Sales Director"
                  : user.auth.type === "shareholder"
                  ? "Shareholder"
                  : user.auth.type === "admin"
                  ? "Admin"
                  : user.auth.type === "manager"
                  ? "Manager"
                  : user.auth.type === "superadmin"
                  ? "Superadmin"
                  : "Shareholder"}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Navigation Section */}
            <nav
                className={`flex-1 p-4 ${
                    isCollapsed
                        ? "space-y-0 space-x-2 flex flex-row overflow-x-auto md:flex-col md:space-x-0 md:space-y-1"
                        : "space-y-1"
                }`}
            >
        {visibleRoutes.map((route, index) => {
          const isActive = isActiveRoute(route.path);
          const IconComponent = route.Icon;
          
          return (
            <Link
              key={index}
              to={route.path}
              className={`flex items-center justify-between px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                                isCollapsed
                                    ? "flex-shrink-0 whitespace-nowrap"
                                    : ""
                            } ${
                isActive
                                    ? isDarkMode
                                        ? "bg-blue-900 text-blue-200"
                                        : "bg-blue-50 text-blue-700"
                                    : isDarkMode
                                    ? "text-gray-300 hover:bg-gray-800 hover:text-gray-100"
                                    : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              <div className="flex items-center space-x-3">
                                <IconComponent
                                    size={18}
                                    className={
                                        isActive
                                            ? isDarkMode
                                                ? "text-blue-200"
                                                : "text-blue-700"
                                            : isDarkMode
                                            ? "text-gray-400"
                                            : "text-gray-500"
                                    }
                                />
                                {!isCollapsed && <span>{route.name}</span>}
              </div>
            </Link>
          );
        })}

                {/* Footer Section */}
                <div
                    className={` border-t ${
                        isDarkMode ? "border-gray-700" : "border-gray-200"
                    } ${
                        isCollapsed
                            ? "flex flex-row space-x-2 md:block md:space-x-0"
                            : ""
                    }`}
                >
        {/* Dark Mode Toggle */}
        <button
          onClick={() => setIsDarkMode(!isDarkMode)}
                        className={`flex items-center ${
                            isCollapsed
                                ? "justify-center flex-shrink-0"
                                : "justify-between"
                        } ${
                            isCollapsed ? "md:w-full" : "w-full"
                        } px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
            isDarkMode 
                                ? "text-gray-300 hover:bg-gray-800 hover:text-gray-100"
                                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
          }`}
        >
          <div className="flex items-center space-x-3">
                            {isDarkMode ? (
                                <FiSun
                                    size={18}
                                    className={
                                        isDarkMode
                                            ? "text-gray-400"
                                            : "text-gray-500"
                                    }
                                />
                            ) : (
                                <FiMoon
                                    size={18}
                                    className={
                                        isDarkMode
                                            ? "text-gray-400"
                                            : "text-gray-500"
                                    }
                                />
                            )}
                            {!isCollapsed && (
                                <span>
                                    {isDarkMode ? "Light Mode" : "Dark Mode"}
                                </span>
                            )}
          </div>
        </button>

                    {/* Change Password Link */}
                    <Link
                        to="/change-password"
                        className={`flex items-center ${
                            isCollapsed
                                ? "justify-center flex-shrink-0"
                                : "justify-between"
                        } ${
                            isCollapsed ? "md:w-full" : "w-full"
                        } px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                            isDarkMode
                                ? "text-gray-300 hover:bg-gray-800 hover:text-gray-100"
                                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                        }`}
                    >
                        <div className="flex items-center space-x-3">
                            <FiLock
                                size={18}
                                className={
                                    isDarkMode
                                        ? "text-gray-400"
                                        : "text-gray-500"
                                }
                            />
                            {!isCollapsed && <span>Change Password</span>}
                        </div>
                    </Link>

        {/* Logout Button */}
        <button
          onClick={user.auth.logout}
                        className={`flex items-center ${
                            isCollapsed
                                ? "justify-center flex-shrink-0"
                                : "justify-between"
                        } ${
                            isCollapsed ? "md:w-full" : "w-full"
                        } px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
            isDarkMode 
                                ? "text-gray-300 hover:bg-gray-800 hover:text-gray-100"
                                : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
          }`}
        >
          <div className="flex items-center space-x-3">
                            <IoIosLogOut
                                size={18}
                                className={
                                    isDarkMode
                                        ? "text-gray-400"
                                        : "text-gray-500"
                                }
                            />
            {!isCollapsed && <span>Logout</span>}
          </div>
        </button>
                </div>
      </nav>
    </div>
  );
};

export default withUser(Sidebar);
